
let publicEnvPromise: Promise<Record<string, string | undefined>> | null = null;
let publicEnvCache: Record<string, string | undefined> | null = null;

export async function buildConfigVariables() {
  const env = await getPublicEnv();
  const cfg = {
    NEXT_PUBLIC_BACKEND_URL: env.NEXT_PUBLIC_BACKEND_URL,
    NEXT_PUBLIC_FRONTEND_URL: env.NEXT_PUBLIC_FRONTEND_URL,
    ENVIRONMENT: env.NEXT_PUBLIC_ENVIRONMENT,
    SIGNUP_WITH_SOCIAL_ENABLED: env.NEXT_PUBLIC_SIGNUP_WITH_SOCIAL_ENABLED,
    SIGNUP_WITH_APPLE_ENABLED: env.NEXT_PUBLIC_SIGNUP_WITH_APPLE_ENABLED,
    SIGNUP_WITH_GOOGLE_ENABLED: env.NEXT_PUBLIC_SIGNUP_WITH_GOOGLE_ENABLED,
  };
  return cfg;
}

// Build config lazily
export async function getPublicEnv(): Promise<Record<string, string | undefined>> {
  const keys = [
    "NEXT_PUBLIC_FIREBASE_API_KEY",
    "NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN",
    "NEXT_PUBLIC_FIREBASE_PROJECT_ID",
    "NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET",
    "NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID",
    "NEXT_PUBLIC_FIREBASE_APP_ID",
    "NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID",
    "NEXT_PUBLIC_BACKEND_URL",
    "NEXT_PUBLIC_FRONTEND_URL",
    "NEXT_PUBLIC_ENVIRONMENT",
    "NEXT_PUBLIC_SIGNUP_WITH_SOCIAL_ENABLED",
    "NEXT_PUBLIC_SIGNUP_WITH_APPLE_ENABLED",
    "NEXT_PUBLIC_SIGNUP_WITH_GOOGLE_ENABLED",
  ];

  const envVals: Record<string, string | undefined> = {};
  keys.forEach((k) => {
    envVals[k] = (process.env as any)[k];
  });

  const missing = keys.filter((k) => !envVals[k]);
  if (missing.length && typeof window !== "undefined") {
    if (publicEnvCache) return publicEnvCache;
    if (!publicEnvPromise) {
      // Use the existing debug endpoint to retrieve public envs at runtime
      publicEnvPromise = fetch("/api/debug/env", {
        headers: { "debug-token": "memocipe-debug-2024" },
      })
        .then((r) => (r.ok ? r.json() : {}))
        .catch(() => ({}));
    }
    const fetched = await publicEnvPromise;
    keys.forEach((k) => {
      if (!envVals[k] && fetched && typeof fetched[k] === "string") {
        envVals[k] = fetched[k];
      }
    });
    publicEnvCache = envVals;
  }
  return envVals;
}